import type { ItemSummary } from '@/types/item/ItemSummary';

import { ApiHosts, handleResponseWithNon200Errors, makePost } from '@/redux/api/helpers';

type FetchImageSearchResultsParams = {
    authToken: string;
    count: number;
    deployment: string;
    excludedAuctioneers: string[];
    imageData: string;
    ipAddress: string;
};

type ImageSearchResponse = {
    error: boolean;
    payload: {
        items: ItemSummary[];
    };
};

/**
 * POSTs a base64 image to the search-party BFF (`/search/by-image`) and resolves the hydrated
 * similar-lot cards — the same digested shape the similar-items flow returns. search-party runs
 * the visual search on the similar-lots service; this client never talks to that service directly.
 * @see https://search-party-DEPLOYMENT.liveauctioneers.com/search/by-image
 */
export const fetchImageSearchResults = ({
    authToken,
    count,
    deployment,
    excludedAuctioneers,
    imageData,
    ipAddress,
}: FetchImageSearchResultsParams) =>
    new Promise<ImageSearchResponse>((resolve, reject) => {
        const request = makePost({
            apiPath: 'by-image',
            authToken,
            deployment,
            ipAddress,
            path: ApiHosts.Search,
            useCacheKey: false,
        });

        request.send({
            count,
            imageData,
            ...(excludedAuctioneers.length > 0 && { excludedAuctioneers }),
        });
        request.end((err, response) => handleResponseWithNon200Errors({ err, reject, resolve, response }));
    });
